import { isRef, unref } from 'vue';
import { useEventListener } from '@vueuse/core';
import { isEnter } from 'shared/helpers/KeyboardHelpers';

const resolveEnabled = enabled => {
  if (typeof enabled === 'function' && !isRef(enabled)) {
    return !!enabled();
  }
  return !!unref(enabled);
};

const isSkippableTarget = target => {
  if (!target) return false;

  const tag = target.tagName;
  if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (target.isContentEditable) return true;
  if (String(target.className || '').includes('ProseMirror')) return true;
  if (target.closest?.('[role="listbox"], [role="menu"]')) return true;

  const control = target.closest?.('button, a');
  if (
    control?.closest('dialog, .modal-container') &&
    control.getAttribute('type') !== 'submit'
  ) {
    return true;
  }

  return false;
};

export const useConfirmOnEnter = ({ enabled, onConfirm, isTopmost } = {}) => {
  useEventListener(
    document,
    'keydown',
    event => {
      if (!resolveEnabled(enabled)) return;
      if (!isEnter(event) || event.repeat || event.isComposing) return;
      if (event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) {
        return;
      }
      if (isSkippableTarget(event.target)) return;
      if (isTopmost && !isTopmost()) return;

      event.preventDefault();
      event.stopPropagation();
      onConfirm();
    },
    { capture: true }
  );
};
